export default class TabbedContentSlide {
	public slideEl: Element;
	public navElList: Element[] = [];
	private rootClassName: string;

	constructor({ slideEl, navElList, rootClassName }: {
		slideEl: Element;
		navElList?: Element[];
		rootClassName: string;
	}) {
		this.slideEl = slideEl;
		this.navElList = navElList;
		this.rootClassName = rootClassName;
	}

	public addModifierClass(className: string): TabbedContentSlide {
		this.slideEl.classList.add(`${this.rootClassName}__slide--${className}`);
		if (this.navElList.length) {
			this.navElList.forEach(el => {
				const role = el.getAttribute('data-role');
				el.classList.add(`${this.rootClassName}__${role}--${className}`);
			});
		}
		return this;
	}

	public removeModifierClass(className: string): TabbedContentSlide {
		this.slideEl.classList.remove(`${this.rootClassName}__slide--${className}`);
		if (this.navElList.length) {
			this.navElList.forEach(el => {
				const role = el.getAttribute('data-role');
				el.classList.remove(`${this.rootClassName}__${role}--${className}`);
			});
		}
		return this;
	}
}
